export const BASE_PATHS = {
  IMAGES: "/spinesim/data",
};
